var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mapUrl)?_c('iframe',{ref:"mapref",attrs:{"src":_vm.mapUrl,"scrolling":"no","marginheight":"0","width":"100%","height":"100%;","frameborder":"0"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }